import { useSelector } from "react-redux";

import { selectUTMParams } from "../../store/reducers/utm";

export const useGetUTMParams = () => {
  const utmParams = useSelector(selectUTMParams);

  return () => {
    if (!utmParams) {
      return undefined;
    }

    return Object.entries(utmParams)
      .map(([key, value]) => `${key}=${value}`)
      .join("&");
  };
};
